import {Grid, Pillar, SectionIntro, Image, Statistic} from '@primer/react-brand'
import {Spacer, SectionVisual} from './_shared'
import SectionHero from './components/SectionHero/SectionHero'

export default function Security() {
  return (
    <section id="security" className="lp-Section">
      <div className="lp-SectionBlock">
        <div className="lp-SectionBlock-content">
          <Spacer size="96px" size1012="148px" />

          <SectionVisual visual="shield" />

          <SectionIntro className="sh-SectionIntro" align="center" fullWidth>
            <SectionIntro.Heading as="h2" size="3">
              Built-in application security <br className="lp-breakText" /> where found means fixed
            </SectionIntro.Heading>

            <SectionIntro.Description>
              Use AI to find and fix vulnerabilities—freeing your teams to ship more secure software faster.
            </SectionIntro.Description>
          </SectionIntro>

          <Spacer size="40px" size1012="80px" />

          <SectionHero
            visual={{
              url: '/images/modules/site/home24/security/hero.webp',
              alt: 'TODO',
            }}
            text={{
              title: 'Apply fixes in seconds.',
              description:
                ' Spend less time fixing vulnerabilities and more time building features with Copilot Autofix',
              link: {
                url: '#TODO',
                text: 'Explore GitHub Advanced Security',
              },
            }}
          />
        </div>
      </div>

      <div className="lp-SectionBlock">
        <div className="lp-SectionBlock-content lp-SectionBlock-content--lines">
          <Grid className="Security-grid Security-grid--hasPillars">
            <Grid.Column className="Security-gridColumn" span={{xsmall: 12, medium: 6, large: 4}}>
              <Pillar>
                <Pillar.Description className="Security-pillarDescription">
                  <em>Solve security debt.</em> Leverage AI-assisted security campaigns to reduce application
                  vulnerabilities and zero-day attacks.
                </Pillar.Description>
                <Pillar.Link href="#TODO">Discover security campaigns</Pillar.Link>
              </Pillar>

              <Image
                className="Security-gridImage"
                src="/images/modules/site/home24/security/pillar-1.webp"
                alt="TODO"
              />
            </Grid.Column>

            <Grid.Column className="Security-gridColumn" span={{xsmall: 12, medium: 6, large: 4}}>
              <Pillar>
                <Pillar.Description className="Security-pillarDescription">
                  <em>Dependencies you can depend on.</em> Confidently update vulnerable dependences with supported
                  fixes for breaking changes.
                </Pillar.Description>
                <Pillar.Link href="#TODO">Learn about Dependabot</Pillar.Link>
              </Pillar>

              <Image
                className="Security-gridImage"
                src="/images/modules/site/home24/security/pillar-2.webp"
                alt="TODO"
              />
            </Grid.Column>

            <Grid.Column className="Security-gridColumn" span={{xsmall: 12, medium: 6, large: 4}}>
              <Pillar>
                <Pillar.Description className="Security-pillarDescription">
                  <em>Your secrets, your business: protected.</em> Detect, prevent, and remediate leaked secrets across
                  your organization.
                </Pillar.Description>
                <Pillar.Link href="#TODO">Read about secret scanning</Pillar.Link>
              </Pillar>

              <Image
                className="Security-gridImage"
                src="/images/modules/site/home24/security/pillar-3.webp"
                alt="TODO"
              />
            </Grid.Column>
          </Grid>

          <Grid className="Security-grid" style={{marginTop: 0}}>
            <Grid.Column className="Security-gridColumn" span={{xsmall: 12, medium: 6}}>
              <Statistic>
                <Statistic.Heading size="4">7x faster</Statistic.Heading>
                <Statistic.Description className="Security-statisticDescription">
                  vulnerability fixes with GitHub<sup>2</sup>
                </Statistic.Description>
              </Statistic>
            </Grid.Column>

            <Grid.Column className="Security-gridColumn" span={{xsmall: 12, medium: 6}}>
              <Statistic>
                <Statistic.Heading size="4">90% coverage</Statistic.Heading>
                <Statistic.Description className="Security-statisticDescription">
                  of alert types in all supported languages with Copilot Autofix<sup>3</sup>
                </Statistic.Description>
              </Statistic>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    </section>
  )
}

try{ Security.displayName ||= 'Security' } catch {}